import LocaleManager from '@services/LocaleManager/LocaleManager'

export default new LocaleManager()



// WEBPACK FOOTER //
// ./src/services/LocaleManager/index.js